export default __webpack_public_path__ + "static/media/authorize_icon_arrow_right.f6346832.svg";